import { z } from 'zod'

// @TODO: Implement variable type
export const variable = z.any().optional()
